module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABQElEQVRYR+2XvUoDQRSFz90YUqxCNiiiKY1BW20T8gT6FAGR+AqCL+GCBEF8BHtB/CkEQUtjMIVVQNmIAf9w53oFtcoEdhaJxZ16zr3fnGnOIYz40Ij3ww6w3/UL/acLEC2kgmQ+jMbGV7E2+zxojhUg2L6tEJmTVMu/xcxetdeYO00EkA/bNQ84ArjFoK4LCDFmxOOyMVx73CgfuwEw6lFjftcFoBC266JrKoA6oA6oA+qAOqAOqAPqQCoHGDiQbHfpEslEu0SElVQAQxczbiS0FiW6+8Pu/Q0A4yWaes+jn8kFr5l7eWnOBuEEEISdKiEeGKV/FhnwJti7I+I9KRjWjsFEld566SxRLJ/YaU1mY7qSuUWX///VMF9LM1pO3Iy+BvjNznT2I150BfBivEUPpXNskbHN+Mfl1PXZCXWfKCtwMAg45IcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/phone.png
// module id = fbCD
// module chunks = 1